class EncVideoCard extends HTMLElement {
  constructor() {
    super();
    this.video = null;
    this.playButton = null;
    this.timestamp = null;
    this.isPlaying = false;
    this.played = false;
    this._onPlayClick = (e) => this.togglePlaybackVideo();
    this._onEnded = () => this.resetPlayback();
    this._onMetadata = () => this.updateTimestamp();
    this._onTimeUpdate = () => this.updateTimestamp();
  }

  connectedCallback() {
    this.video = this.querySelector("video");
    this.playButton = this.querySelector(".enc-video-card__play-button");
    this.timestamp = this.querySelector(".enc-video-time-stamp");
    if (!this.video || !this.playButton) return;

    // Add listeners
    this.playButton.addEventListener("click", this._onPlayClick);
    this.video.addEventListener("ended", this._onEnded);
    this.video.addEventListener("loadedmetadata", this._onMetadata);
    this.video.addEventListener("timeupdate", this._onTimeUpdate);
  }

  disconnectedCallback() {
    if (!this.video || !this.playButton) return;

    // Remove all event listeners
    this.playButton.removeEventListener("click", this._onPlayClick);
    this.video.removeEventListener("ended", this._onEnded);
    this.video.removeEventListener("loadedmetadata", this._onMetadata);
    this.video.removeEventListener("timeupdate", this._onTimeUpdate);
  }

  togglePlaybackVideo() {
    if (!this.video) return;
    this.played = true;
    EncVideoCard.stopAllExcept(this);

    if (this.isPlaying) {
      this.video.pause();
      this.playButton.style.opacity = "1";
      this.isPlaying = false;
      this.updateTimestamp();
    } else {
      this.video.play();
      this.playButton.style.opacity = "0";
      this.isPlaying = true;
      this.updateTimestamp();
    }
  }

  resetPlayback() {
    this.isPlaying = false;
    this.playButton.style.opacity = "1";
  }

  updateTimestamp() {
    if (!this.timestamp || !this.video.duration) return;

    const current = this.formatTime(this.video.currentTime);
    const total = this.formatTime(this.video.duration);

    if (this.isPlaying) {
      this.timestamp.textContent = `${current}`;
    } else {
      if (this.played) this.timestamp.textContent = `${current}`;
      else this.timestamp.textContent = `${total}`;
    }
  }

  formatTime(seconds) {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  }

  static stopAllExcept(currentCard) {
    document.querySelectorAll("enc-video-card").forEach((card) => {
      if (card !== currentCard && card.video && !card.video.paused) {
        card.video.pause();
        card.playButton && (card.playButton.style.opacity = "1");
        card.isPlaying = false;
      }
    });
  }
}

// Define the custom element
customElements.define('enc-video-card', EncVideoCard);